// extracted by mini-css-extract-plugin
module.exports = {"tab":"usertable_tab__DhxhV"};